import { PreventiveCareNoticeLetterTypeEnum } from "@/Common/Models/PreventiveCare/PreventiveCareNoticeLetterTypeEnum";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { APSSFormInboxItem, ApssPatientLink, ConsultationRequestsInboxItem, NotesInboxItem, PendingApprovalsItem, RequestsInboxItem, SentFaxInboxItem } from "./MyNotesInboxItem";
import { MyPreventiveActivityDto } from "./MyPreventiveActivityDto";
import { PreventiveRecallListDto } from "./PreventiveRecallListDto";

class NotesInboxTableItem implements ITableDataSourceItem<NotesInboxItem> {
    public Model: NotesInboxItem;
    public Name: string;

    constructor(model: NotesInboxItem) {
        this.Model = model;
    }
}

class MyConsultationRequestsTableItem implements ITableDataSourceItem<ConsultationRequestsInboxItem> {
    public Model: ConsultationRequestsInboxItem;
    public Name: string;

    constructor(model: ConsultationRequestsInboxItem) {
        this.Model = model;
    }
}

class MyRequestsTableItem implements ITableDataSourceItem<RequestsInboxItem> {
    public Model: RequestsInboxItem;
    public Name: string;

    constructor(model: RequestsInboxItem) {
        this.Model = model;
    }
}

class PreventiveActivitiesTableItem implements ITableDataSourceItem<MyPreventiveActivityDto> {
    public Model: MyPreventiveActivityDto;
    public Name: string;

    constructor(model: MyPreventiveActivityDto) {
        this.Model = model;
    }
}

class PreventiveRecallListTableItem implements ITableDataSourceItem<PreventiveRecallListDto> {
    public Model: PreventiveRecallListDto;
    public Name: string;
    public IsSelected?: boolean;
    public CheckboxDisabled?: boolean;

    constructor(model: PreventiveRecallListDto) {
        this.Model = new PreventiveRecallListDto({ Id: model.PreventiveCareCriteriaId.toString() + model.EmployeeContactFacetId?.toString() + model.PatientContactFacetId.toString(), ...model });

        const settings = portfolioStore.preventiveRecallListModel.get("SavedSettingsContainerState");
        const currentDate = new Date().setHours(0, 0, 0, 0);
        const dateTo = new Date(settings.dateTo).setHours(0, 0, 0, 0);

        this.CheckboxDisabled = dateTo < currentDate || this.Model.LetterType >= PreventiveCareNoticeLetterTypeEnum.SecondLetter;
    }
}

class MyAPSSFormTableItem implements ITableDataSourceItem<APSSFormInboxItem> {
    public Model: APSSFormInboxItem;
    public Name: string;
    public PatientLink: ApssPatientLink;

    public Prerequis: APSSPrerequis[];
    public PrerequisManquant: APSSPrerequis[];
    public PrerequisManquantExistingCount: number;

    public ExpandPrerequis: boolean;

    constructor(model: APSSFormInboxItem) {
        this.Model = model;

        this.Prerequis = [];
        this.PrerequisManquant = [];

        this.initPrerequis();
        this.initPatientLink();
        this.ExpandPrerequis = false;
    }

    public initPatientLink(): void {
        var result: ApssPatientLink = null;

        var ClientTag = cacheStore.ClientIdentifier;

        try {
            result = JSON.parse(this.Model.texteNumDossierDME);

            if (ClientTag != result.T)
                result = null;
        }
        catch (ex) {
        }

        this.PatientLink = result;
    }

    public initPrerequis(): void {
        if (this.Model.lstPrerequis == null)
            return;

        var CleanlstPrequis = this.Model.lstPrerequis == null ? "" : this.Model.lstPrerequis.toString();
        var CleanlstPrerequisManquant = this.Model.lstPrerequisManquant == null ? "" : this.Model.lstPrerequisManquant.toString();

        var tmpPreRequisList = CleanlstPrequis.split(",").filter(x => !IsNullOrWhiteSpace(x)).map(x => {
            var tmpPrerequis = new APSSPrerequis();
            let xSplit = x.split("|");
            tmpPrerequis.Code = xSplit[0].trim();
            tmpPrerequis.Name = (xSplit.length > 1) ? xSplit[1].trim() : "? " + tmpPrerequis.Code;
            return tmpPrerequis;
        });

        tmpPreRequisList = tmpPreRequisList.filter(x => x.Code != "rprt_AUTRES");

        if (this.Model.lstPrerequisManquant != null) {
            var MissingPrerequisList = CleanlstPrerequisManquant.split(",").filter(x => !IsNullOrWhiteSpace(x)).map(x => {
                var tmpPrerequis = new APSSPrerequis();
                tmpPrerequis.IsMissing = true;
                let xSplit = x.split("|");
                tmpPrerequis.Code = xSplit[0].trim();
                tmpPrerequis.Name = (xSplit.length > 1) ? xSplit[1].trim() : "? " + tmpPrerequis.Code;
                return tmpPrerequis;
            });

            tmpPreRequisList.forEach(x => {
                if (MissingPrerequisList.some(y => y.Code.toLowerCase() == x.Code.toLowerCase()))
                    x.IsMissing = true;
                else
                    x.IsMissing = false;
            });

            MissingPrerequisList.forEach(x => {
                if (!tmpPreRequisList.some(y => y.Code.toLowerCase() !== x.Code.toLowerCase()))
                    tmpPreRequisList.push(x);
            });

            this.PrerequisManquant = MissingPrerequisList;
        }

        this.Prerequis = tmpPreRequisList;
        this.PrerequisManquantExistingCount = tmpPreRequisList.filter(x => x.IsMissing).length;
    }

    public static DecodeHtmlCaracters<T>(requetesRaw: any): T {
        var parser = new DOMParser;
        var dom = parser.parseFromString(
            "<!doctype html><body>" + JSON.stringify(requetesRaw),
            "text/html"
        );
        return JSON.parse(dom.body.textContent) as T;
    }

    public static IsGreen(ReqReg_Etat: string): boolean {
        return MyAPSSFormTableItem.lowerCompare(ReqReg_Etat, ["Reçue CRDS", "Réception confirmée"]);
    }

    public static IsPurple(ReqReg_Etat: string): boolean {
        return MyAPSSFormTableItem.lowerCompare(ReqReg_Etat, ["En attente réception CRDS", "En attente confirmation réception", "En attente d’annulation"]);
    }

    public static IsBold(status: string): boolean {
        return MyAPSSFormTableItem.lowerCompare(status, ["443942000", "385642001"]);
    }

    public static IsRedActionRequired(status: string): boolean {
        return MyAPSSFormTableItem.lowerCompare(status, ["255599008"]);
    }

    public IsGreen(): boolean {
        return MyAPSSFormTableItem.IsGreen(this.Model.ReqReg_Etat);
    }

    public IsPurple(): boolean {
        return MyAPSSFormTableItem.IsPurple(this.Model.ReqReg_Etat);
    }

    public IsBold(): boolean {
        return MyAPSSFormTableItem.IsBold(this.Model.etat_code);
    }

    public IsRedActionRequired(): boolean {
        return MyAPSSFormTableItem.IsRedActionRequired(this.Model.etat_code);
    }

    public static lowerCompare(a: string, b: string[]): boolean {
        if (IsNullOrUndefined(a) || !b)
            return false;

        if (typeof a == "string")
            return b.some(x => x.toLowerCase() == a.toLowerCase());
        else {
            try {
                return b.some(x => x.toLowerCase() == (a[0] as string).toLowerCase());
            }
            catch (ex) {
                console.log("Weird Type for Apss Status " + typeof a);
            }
        }

        return false;
    }
}

class APSSPrerequis {
    public Name: string;
    public Code: string;
    public IsMissing: boolean;
}

class MySentFaxTableItem implements ITableDataSourceItem<SentFaxInboxItem> {
    public Model: SentFaxInboxItem;
    public Name: string;
    public IsSelected: boolean;

    constructor(model: SentFaxInboxItem) {
        this.Model = model;
        this.IsSelected = false;
    }
}

class PendingApprovalsTableItem implements ITableDataSourceItem<PendingApprovalsItem> {
    public Model: PendingApprovalsItem;
    public Name: string;

    constructor(model: PendingApprovalsItem) {
        this.Model = model;
    }
}

export {
    MyAPSSFormTableItem,
    MyConsultationRequestsTableItem,
    MyRequestsTableItem,
    MySentFaxTableItem,
    NotesInboxTableItem,
    PendingApprovalsTableItem,
    PreventiveActivitiesTableItem,
    PreventiveRecallListTableItem
};
